// wiki链接：https://www.tapd.cn/60236733/markdown_wikis/show/#1160236733001003613
// IOS请求头值需要是String，不然无法解析
export const X_SOURCES_MAP = {
    HLAPP: '100', // 星财富APP
    HLAPP_WEB: '102', // 星财富H5 web
    HLAPP_MOBILE: '103', // 星财富H5 移动端
    THS_OEM_APP: '110', // 同花顺 APP 同花顺 OEM 版本
    THS_PC: '111', // 同花顺 PC
    WANG_TING: '112', // 网厅
    THS_APP: '113', // 同花顺公版
    THS_I18N_APP: '116', // 同花顺国际版
    PAY_WEB: '122', // 派安盈 Web
    MYLINK_APP: '130', // 中移动香港 APP MyLink
}

// 拦截冻结账户错误码
export const ACCOUNT_INTERCEPT_ERROR_CODE = [111006, 800002]

export const ERROR_CODE_MAP = {
    ERROR_UIN: 100033, // ErrUin             100033
    ERROR_SESSION: 100008, // ErrSession         100008
    ERROR_SESSION_EXPIRE: 100031, // ErrSessionExpire   100031
    ERR_SESSION_REJECTED: 100034, // ErrSessionRejected 100034
    IASIA_UNVALID_SESSION: 201004, // 柜台登录session无效 201004
    ERROR_TRADE_SESSION_EXPIRE: 100032, // 交易密码过期
    MR: 100029, // mr测试会统一返回的错误码
}

// 错误代码
export const ERROR_COCES = {
    SYSTEM_MAINTENANCE: 100029, // 系统维护错误码
    MYLINK_REJECT: 100034, //互踢
    MYLINK_TOKEN_EXPIRED: 100033, // token过期
}

export const THS_I18N_TICKET_KEY = 'thsI18NTicket'

// 加密类型
export const ENCRYPT_TYPES = {
    NO_ENCRYPT: 0, // 不加密
    EDCH: 1, // 临时加密
    LOGIN: 2, // 登录加密
    TRADE: 3, // 交易加密 - 前置校验登录密码的之后需要采用这种加密方式
    FORCE_TRADE: 4, // 强制交易加密 - 强制前置校验登录密码
}
